// TelcoTrack — interní mailing-list skupiny (@protelco.cz) pro HR adresář uživatelů.

/** Skupiny pro tabulku ProTelco s.r.o. (včetně office@). */
export const HR_MAILING_GROUPS_PROTELCO = [
  'team@protelco.cz',
  'lovosice@protelco.cz',
  'montaz@protelco.cz',
  'stavbyvedouci@protelco.cz',
  'zafuk@protelco.cz',
  'optika@protelco.cz',
  'projekce@protelco.cz',
  'nga@protelco.cz',
  'prace@protelco.cz',
  'reklamace@protelco.cz',
  'info@protelco.cz',
  'pardubice@protelco.cz',
  'ostrava@protelco.cz',
  'management@protelco.cz',
  'office@protelco.cz',
] as const;

/** Skupiny pro Fiber Beta s.r.o. (bez office@). */
export const HR_MAILING_GROUPS_FIBER_BETA = HR_MAILING_GROUPS_PROTELCO.filter(
  (g) => g !== 'office@protelco.cz',
);

export type HrMailingGroupId = (typeof HR_MAILING_GROUPS_PROTELCO)[number];

export const HR_MAILING_GROUP_LABELS: Record<HrMailingGroupId, string> = {
  'team@protelco.cz': 'Team',
  'lovosice@protelco.cz': 'Lovosice',
  'montaz@protelco.cz': 'Montáž',
  'stavbyvedouci@protelco.cz': 'Stavbyvedoucí',
  'zafuk@protelco.cz': 'Zafuk',
  'optika@protelco.cz': 'Optika',
  'projekce@protelco.cz': 'Projekce',
  'nga@protelco.cz': 'NGA',
  'prace@protelco.cz': 'Práce',
  'reklamace@protelco.cz': 'Reklamace',
  'info@protelco.cz': 'Info',
  'pardubice@protelco.cz': 'Pardubice',
  'ostrava@protelco.cz': 'Ostrava',
  'management@protelco.cz': 'Management',
  'office@protelco.cz': 'Office',
};

const MAILING_GROUP_SET = new Set<string>(HR_MAILING_GROUPS_PROTELCO);

export function isHrMailingGroupId(value: unknown): value is HrMailingGroupId {
  return typeof value === 'string' && MAILING_GROUP_SET.has(value.trim().toLowerCase());
}

/** Normalizuje a deduplikuje skupiny; neznámé e-maily zahodí. */
export function normalizeHrMailingGroups(values: unknown): HrMailingGroupId[] {
  if (!Array.isArray(values)) return [];
  const out: HrMailingGroupId[] = [];
  const seen = new Set<string>();
  for (const raw of values) {
    const id = String(raw ?? '').trim().toLowerCase();
    if (!isHrMailingGroupId(id) || seen.has(id)) continue;
    seen.add(id);
    out.push(id);
  }
  return out.sort();
}

export function hrMailingGroupsForCompany(
  companyId: 'protelco' | 'fiber_beta' | 'extermis' | null | undefined,
): readonly HrMailingGroupId[] {
  if (companyId === 'fiber_beta') return HR_MAILING_GROUPS_FIBER_BETA;
  if (companyId === 'protelco') return HR_MAILING_GROUPS_PROTELCO;
  return HR_MAILING_GROUPS_PROTELCO;
}
